import { render, staticRenderFns } from "./safe-manage.vue?vue&type=template&id=9238e5f4&scoped=true&"
import script from "./safe-manage.vue?vue&type=script&lang=js&"
export * from "./safe-manage.vue?vue&type=script&lang=js&"
import style0 from "./safe-manage.vue?vue&type=style&index=0&id=9238e5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9238e5f4",
  null
  
)

export default component.exports